import { Link } from "@inertiajs/react"
import {
  ArrowUpDown,
  FileStack,
  FileText,
  ImageIcon,
  Lock,
  PenLine,
  Scissors,
} from "lucide-react"

import { Button } from "@/components/ui/button"

const tools = [
  { title: "Merge", icon: FileStack, href: "/merge-pdf" },
  { title: "Split", icon: Scissors, href: "/split-pdf" },
  { title: "Reorder", icon: ArrowUpDown, href: "/reorder-pdf" },
  { title: "Protect", icon: Lock, href: "/protect-pdf" },
  { title: "Sign", icon: PenLine, href: "/sign-pdf" },
  { title: "Image to PDF", icon: ImageIcon, href: "/image-to-pdf" },
]

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <FileText className="text-muted-foreground h-16 w-16" />
      <h2 className="mt-4 text-xl font-semibold">No documents yet</h2>
      <p className="text-muted-foreground mt-2">
        Use any of our PDF tools to get started.
      </p>
      <div className="mt-8 grid grid-cols-3 gap-3">
        {tools.map((tool) => (
          <Button key={tool.href} variant="outline" asChild>
            <Link href={tool.href} className="flex items-center gap-2">
              <tool.icon className="h-4 w-4" />
              {tool.title}
            </Link>
          </Button>
        ))}
      </div>
    </div>
  )
}
